import React, { Component } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {
    postFacturaOrdenes,
    // fetchOrdenEstadoVentaApi — estado interno deshabilitado
    postSolicitudAnulacionOrdenApi,
    postAnulacionReversionOrdenApi,
    putReemplazarComprobanteOrdenApi
} from '../../../api/axios';
import { fetchMotivosSolicitudAnulacion, getFacturaOrdenes } from '../../../actions/ordenesActions';
// import EstadoVentaAdm from "./EstadoVentaAdm"; /* estado interno deshabilitado */
import SolicitudAnulacion from "./SolicitudAnulacion";
import AnulacionReversion from "./AnulacionReversion";
import FormularioDevolucion from "./FormularioDevolucion";
import FormularioDevolucionVte from "./FormularioDevolucionVte";
import StatusTimeline from "../../General/StatusTimeline";
import { toast } from '../../../utilities/appToast';
import { formatFile, base64ToArrayBuffer, saveByteArray } from "../../../utilities/formatFile";
import { fileToBase64 } from "../../../utilities/formatFile";
import { filtroHoySplitted, filtroHoy } from "../../../utilities/fechasFiltro";
import { idEstadosOrden } from "../../../helper/ordenHelper";
import { buildOrderTimeline } from "../../../helper/statusTimelineHelper";
import PropTypes from 'prop-types';

// Wrapper para usar hooks en class component
function EstadosOrdenWrapper(props) {
    const navigate = useNavigate();
    return <EstadosOrden {...props} navigate={navigate} />;
}
const fechaHoySplitted = filtroHoySplitted();
const idEstados = idEstadosOrden;

class EstadosOrden extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: [...this.props.orden.estado].reverse(),
            factura: "",
            notaDeCredito: "",
            filaFacturado: false,
            filaAnulado: false,
            btnFacturar: false,
            btnAnular: false,
            fechaFacturado: "",
            fechaAnulado: "",
            clickEliminarFactura: false,
            clickEliminarAnulado: false,
            facturaCargada: false,
            anuladaCargada: false,
            facturaDisponible: false,
            notaCreditoDisponible: false,
            comprobantePendienteDisponible: false,
            motivosSolicitudAnulacion: [],
            habilitarInputs: false,
            setHabilitarInputsVte: false,
            montoDevolver: "",
            cuentaBancaria: "",
            cuil: "",
            numeroComprobante: "",
            banco: "",
            numCuenta: "",
            cbu: "",
            alias: "",
            dni: "",
            showModalDevolucion: false,
            idMotivoAnulacion: "",

        }
    }

    componentDidMount() {
        this.syncEstadoDesdeOrden();

        const { isSellerAdmin, isSeller, isAdminMod, isCategory, isSoloLectura } = this.props.userType;
        if (!isSoloLectura && (isSellerAdmin || isSeller || isAdminMod || isCategory)) {
            let request = fetchMotivosSolicitudAnulacion();
            request.then(res => {
                const motivos = Array.isArray(res.motivosSolicitudAnulacion)
                    ? res.motivosSolicitudAnulacion
                    : [];

                this.setState({ motivosSolicitudAnulacion: motivos });
            }).catch(err => {
                toast.error("No se encontraron motivos para solicitud de anulaci�n");
            });
        }
        /* Estado interno deshabilitado
        if (this.props.orden?.idOrden && this.props.userId) {
            fetchOrdenEstadoVentaApi({
                idUsuario: this.props.userId,
                idVenta: this.props.orden.idOrden
            }).then((res) => {
                this.setState({ estadoVentaAprobado: res?.estado !== "Anulado" });
            }).catch(() => {
                this.setState({ estadoVentaAprobado: null });
            });
        }
        */
    }

    componentDidUpdate(prevProps) {
        const prevIdOrden = prevProps.orden?.idOrden;
        const currIdOrden = this.props.orden?.idOrden;
        const estadoCambio = prevProps.orden?.estado !== this.props.orden?.estado;

        if (prevIdOrden !== currIdOrden || estadoCambio) {
            this.syncEstadoDesdeOrden();
        }
    }

    getEstadoId = (item) => Number(item?.idEstado ?? item?.IdEstado);

    hasEstadoComprobante = (estado) => Boolean(estado?.comprobante || estado?.Comprobante || estado?.archivo || estado?.Archivo);

    hasIdEstadoDuplicadoError = (err) => {
        const errores = err?.response?.data?.errores || err?.response?.data?.errors || [];
        if (!Array.isArray(errores)) return false;
        return errores.some((errorItem) => {
            const msg = typeof errorItem === "string"
                ? errorItem
                : (errorItem?.errorMesage || errorItem?.ErrorMesage || "");
            const normalized = String(msg).toLowerCase();
            return normalized.includes("idestad") && normalized.includes("asignado");
        });
    }

    reemplazarComprobante = async ({ idEstado, file }) => {
        const orden = this.props.orden;
        const idOrden = orden?.idOrden;
        const idSeller = orden?.seller?.codigo ?? this.props.idSeller;

        if (!idOrden || !idSeller || !idEstado) {
            toast.error("No se pudo determinar la orden/seller para reemplazar el comprobante");
            return;
        }

        if (!file) return;

        const base64 = await fileToBase64(file);
        const request = {
            idSeller: Number(idSeller),
            fileName: `${idOrden}.pdf`,
            fileContent: base64
        };

        putReemplazarComprobanteOrdenApi(request)
            .then(() => {
                if (Number(idEstado) === idEstados.anulado) {
                    this.setState({ notaCreditoDisponible: true });
                } else if (Number(idEstado) === idEstados.facturado) {
                    this.setState({ facturaDisponible: true });
                } else if (Number(idEstado) === idEstados.pendiente) {
                    this.setState({ comprobantePendienteDisponible: true });
                }
                toast.success("Comprobante reemplazado");
            })
            .catch((err) => {
                const errores = err?.response?.data?.errors || err?.response?.data?.errores;
                if (Array.isArray(errores)) {
                    errores.forEach((e) => toast.error(e?.errorMesage ?? e?.ErrorMesage ?? e));
                    return;
                }
                toast.error("No se pudo reemplazar el comprobante");
            });
    }

    triggerFilePicker = (inputId) => {
        const input = document.getElementById(inputId);
        if (input) input.click();
    }

    renderComprobanteActions = ({ idEstado, disponible, onDownload, onUploadInputId, onUploadChange, showWhen = true }) => {
        const canEdit = !this.props.userType?.isSoloLectura;
        if (!showWhen) return null;
        const showUpload = canEdit && !disponible;
        const showDownload = !!disponible;
        const showReplace = canEdit;

        return (
            <div className="mt-2">
                <div className="d-flex flex-column gap-2" style={{ maxWidth: 260 }}>
                    {showUpload && (
                        <div>
                            <input
                                id={onUploadInputId}
                                type="file"
                                accept=".pdf"
                                className="d-none"
                                onChange={onUploadChange}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary w-100 text-start"
                                onClick={() => this.triggerFilePicker(onUploadInputId)}
                            >
                                <i className="mdi mdi-arrow-up-bold me-1" />
                                Cargar comprobante
                            </button>
                        </div>
                    )}

                    {showDownload && (
                        <button
                            type="button"
                            className="btn btn-sm background-rojo-megatone waves-light w-100 text-start"
                            onClick={onDownload}
                        >
                            <i className="mdi mdi-arrow-down-bold me-1" />
                            Descargar comprobante
                        </button>
                    )}

                    {showReplace && (
                        <div>
                            <input
                                id={`${onUploadInputId}-replace`}
                                type="file"
                                accept=".pdf"
                                className="d-none"
                                onChange={(e) => this.reemplazarComprobante({ idEstado, file: e.target?.files?.[0] })}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-light border w-100 text-start"
                                onClick={() => this.triggerFilePicker(`${onUploadInputId}-replace`)}
                            >
                                <i className="mdi mdi-swap-horizontal me-1" />
                                Reemplazar comprobante
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderTimelineActions = ({ idEstado, disponible, onDownload, onPickUpload, showWhen }) => {
        const canEdit = !this.props.userType?.isSoloLectura;
        if (!showWhen) return null;
        if (!canEdit && !disponible) return null;

        const primaryLabel = !canEdit || disponible ? "Descargar" : "Cargar";
        const primaryIcon = !canEdit || disponible ? "mdi-arrow-down-bold" : "mdi-arrow-up-bold";
        const primaryAction = !canEdit || disponible ? onDownload : onPickUpload;

        return (
            <>
                <button
                    type="button"
                    className="status-timeline__action-btn status-timeline__action-btn--primary"
                    onClick={primaryAction}
                >
                    <i className={`mdi ${primaryIcon}`} aria-hidden="true" />
                    {primaryLabel}
                </button>

                {canEdit && (
                    <button
                        type="button"
                        className="status-timeline__action-btn status-timeline__action-btn--muted"
                        onClick={onPickUpload}
                    >
                        <i className="mdi mdi-swap-horizontal" aria-hidden="true" />
                        Reemplazar
                    </button>
                )}
            </>
        );
    }

    syncEstadoDesdeOrden = () => {
        const orden = this.props.orden || {};
        const estadosOrden = Array.isArray(orden.estado) ? orden.estado : [];
        const estadosReverso = [...estadosOrden].reverse();
        const estadoFacturado = estadosOrden.find((item) => this.getEstadoId(item) === idEstados.facturado);
        const estadoAnulado = estadosOrden.find((item) => this.getEstadoId(item) === idEstados.anulado);
        const estadoPendiente = estadosOrden.find((item) => this.getEstadoId(item) === idEstados.pendiente);
        const anuladaMegatone = orden?.anulacionMegatone?.anulado === true;
        const mostrarAnulado = Boolean(estadoAnulado) || anuladaMegatone;

        this.setState({
            estados: estadosReverso,
            facturaCargada: Boolean(estadoFacturado),
            filaFacturado: Boolean(estadoFacturado),
            btnFacturar: Boolean(estadoFacturado),
            fechaFacturado: estadoFacturado?.fecha?.slice(0, 10) || "",
            anuladaCargada: mostrarAnulado,
            filaAnulado: mostrarAnulado,
            btnAnular: mostrarAnulado,
            fechaAnulado: estadoAnulado?.fecha?.slice(0, 10) || (mostrarAnulado ? filtroHoy() : ""),
            facturaDisponible: this.hasEstadoComprobante(estadoFacturado),
            notaCreditoDisponible: this.hasEstadoComprobante(estadoAnulado),
            comprobantePendienteDisponible: this.hasEstadoComprobante(estadoPendiente)
        });

        this.cargarComprobanteFacturado();
        this.cargarComprobanteAnulado();
        this.cargarComprobantePendiente();
    }

    onSubmit = (event) => {
        event.preventDefault();

        const {
            montoDevolver,
            titularCompra,
            banco,
            numCuenta,
            cbu,
            cuil,
            alias,
            dni,
            numeroComprobante,
            cupon,
            cuponVTE,
            terminal,
            tarjeta,
            cuotas,
            autorizacion,
            autorizacionVTE
        } = this.state;

        const datosCuentaBancaria = {
            montoADevolver: montoDevolver,
            titularCompra: titularCompra,
            banco: banco,
            numCuenta: numCuenta,
            cbu: cbu,
            cuil: cuil,
            alias: alias,
            dni: dni,
            numeroComprobante: numeroComprobante,
            cupon: cupon && !Number.isNaN(Number.parseInt(cupon)) ? Number.parseInt(cupon) : null,
            autorizacion: autorizacion && !Number.isNaN(Number.parseInt(autorizacion)) ? Number.parseInt(autorizacion) : null,
        };

        const anulacionVTE = {
            cuponVTE: cuponVTE && !Number.isNaN(Number.parseInt(cuponVTE)) ? Number.parseInt(cuponVTE) : null,
            terminal: terminal?.trim() || null,
            tarjeta: tarjeta?.trim() || null,
            cuotas: cuotas && !Number.isNaN(Number.parseInt(cuotas)) ? Number.parseInt(cuotas) : null,
            autorizacionVTE: autorizacionVTE && !Number.isNaN(Number.parseInt(autorizacionVTE)) ? Number.parseInt(autorizacionVTE) : null,
        };

        const isCuentaBancariaVacia = Object.values(datosCuentaBancaria).every(
            (value) => value === "" || value === null || value === undefined
        );

        const isAnulacionVTEVacia = Object.values(anulacionVTE).every(
            (value) => value === "" || value === null || value === undefined
        );

        const cleanAnulacionVTE = (obj) => {
            if (!obj) return null;

            const cleaned = Object.entries(obj).reduce((acc, [key, val]) => {
                if (
                    val !== null &&
                    val !== undefined &&
                    val !== '' &&
                    !(typeof val === 'number' && Number.isNaN(val))
                ) {
                    acc[key] = val;
                }
                return acc;
            }, {});

            return Object.keys(cleaned).length === 0 ? null : cleaned;
        };

        const anulacionVTEFinal = cleanAnulacionVTE(anulacionVTE);

        const motivoAnula = Number.parseInt(this.state.idMotivoAnulacion);

        const request = {
            idVenta: this.props.orden.idOrden,
            idSeller: this.props.idSeller,
            idMotivoAnulacion: Number.isNaN(Number.parseInt(this.state.idMotivoAnulacion, 1))
                ? null
                : Number.parseInt(this.state.idMotivoAnulacion, 1),
            solicitarAnulacion: true
        };

        postSolicitudAnulacionOrdenApi(request)
            .then(res => {
                toast.success("Solicitud de anulación enviada");
                const requestAnulacion = {
                    idVenta: this.props.orden.idOrden,
                    devolucionDinero: true,
                    rechazado: false,
                    idSeller: this.props.idSeller,
                    idMotivoAnula: motivoAnula,
                    //solicitarAnulacion: true,
                    anulacionVTE: isAnulacionVTEVacia ? null : anulacionVTEFinal,
                    datosCuentaBancaria: isCuentaBancariaVacia ? null : datosCuentaBancaria
                };
                return postAnulacionReversionOrdenApi(requestAnulacion);
            })
            .then(res => {
                toast.success("Estado de orden actualizado");
                this.goToOrdenes();
            })
            .catch(err => {
                (err.response?.data.errores)
                    ? err.response?.data.errores.forEach(error => toast.error(error))
                    : toast.error("Faltan datos en el formulario");
            });
    };

  cargarComprobante = async (idEstado, stateFileKey, stateDisponibleKey, fallbackEstado = null) => {
    if (!this.props.orden?.idOrden) {
      this.setState({ [stateDisponibleKey]: false });
      return;
    }

    try {
      const archivo = await getFacturaOrdenes(this.props.orden.idOrden, idEstado);
      this.setState({
        [stateFileKey]: archivo,
        [stateDisponibleKey]: Boolean(archivo)
      });
    } catch {
      if (fallbackEstado != null) {
        try {
          const archivoFallback = await getFacturaOrdenes(this.props.orden.idOrden, fallbackEstado);
          this.setState({
            [stateFileKey]: archivoFallback,
            [stateDisponibleKey]: Boolean(archivoFallback)
          });
        } catch {
          this.setState((prev) => (
            prev[stateDisponibleKey]
              ? {}
              : { [stateDisponibleKey]: false }
          ));
        }
        return;
      }
      this.setState((prev) => (
        prev[stateDisponibleKey]
          ? {}
          : { [stateDisponibleKey]: false }
      ));
    }
  }

    cargarComprobanteFacturado = () => {
        this.cargarComprobante(idEstados.facturado, "factura", "facturaDisponible");
    }

    cargarComprobanteAnulado = () => {
        this.cargarComprobante(idEstados.anulado, "notaDeCredito", "notaCreditoDisponible", idEstados.facturado);
    }

    cargarComprobantePendiente = () => {
        this.cargarComprobante(idEstados.pendiente, "factura", "comprobantePendienteDisponible", idEstados.facturado);
    }

  descargarFactura = async (idEstado) => {
    try {
      const res = await getFacturaOrdenes(this.props.orden.idOrden, idEstado);
      const pdfData = base64ToArrayBuffer(res);
      saveByteArray(idEstado === idEstados.anulado ? "NotaCredito" : "Factura", pdfData);
      toast.success("Descarga realizada");
    } catch {
      if (idEstado === idEstados.anulado) {
        try {
          const resFallback = await getFacturaOrdenes(this.props.orden.idOrden, idEstados.facturado);
          const pdfData = base64ToArrayBuffer(resFallback);
          saveByteArray("NotaCredito", pdfData);
          toast.success("Descarga realizada");
        } catch {
          toast.error("No hay comprobante disponible para descargar");
        }
        return;
      }
      toast.error("No hay comprobante disponible para descargar");
    }
  }

    descargarFacturaAdmin = (e) => {
        let pdfData = base64ToArrayBuffer(e.target.id);
        saveByteArray("Factura", pdfData);
        toast.success("Descarga realizada");
    }

    inputCreditoFile = async (dataPdf) => {
        let pdfFormatted = await formatFile(dataPdf, "pdf");
        this.setState({ notaDeCredito: pdfFormatted, notaCreditoDisponible: false });
    }

    inputFacturaFile = async (dataPdf) => {
        let one_week = this.checkDaysToUploadFactura();

        if (!one_week) {
            toast.warn("No puede subir / eliminar la factura pasados los 7 dias de facturado");
            return;
        }

        let pdfFormatted = await formatFile(dataPdf, "pdf");
        this.setState({ factura: pdfFormatted, facturaDisponible: false, comprobantePendienteDisponible: false });
    }

    checkDaysToUploadFactura = () => {
        let date = new Date();
        let today = new Date().now();
        let sevenDaysAgo = date.setDate(date.getDate() - 8);
        let fechaFacturado = new Date(this.state.fechaFacturado.replaceAll("-", "/")).now();

        if (Number.isNaN(fechaFacturado)) {
            return true;
        }

        return sevenDaysAgo <= fechaFacturado && today >= fechaFacturado;
    }

    eliminarFilaFacturado = () => {
        this.setState(prevState => ({
            clickEliminarFactura: prevState.facturaCargada,
            btnFacturar: false,
            filaFacturado: false,
            estados: prevState.estados.filter(estado => estado.updateFacturado !== true)
        }));
    }

    eliminarFilaAnulado = () => {
        this.setState(prevState => ({
            clickEliminarAnulado: prevState.anuladaCargada,
            filaAnulado: false,
            btnAnular: false,
            estados: prevState.estados.filter(estado => estado.updateAnulado !== true)
        }));
    }

    agregarFacturado = () => {
        const newEstadoFacturado = {
            idEstado: idEstadosOrden.facturado,
            fecha: filtroHoy(),
            updateFacturado: true
        }

        this.setState(prevState => ({
            filaFacturado: true,
            btnFacturar: true,
            estados: prevState.estados.concat([newEstadoFacturado]),
            updateFacturado: true
        }));
    }

    postArchivoFactura = () => {
        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.facturado,
            "comprobante": this.state.factura
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Factura creada");
            this.setState({ facturaDisponible: true, comprobantePendienteDisponible: true });
            this.goToOrdenes();
        }).catch(err => {
            if (this.hasIdEstadoDuplicadoError(err)) {
                this.setState({ facturaDisponible: true, comprobantePendienteDisponible: true });
            }
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    postArchivoNota = () => {
        if (this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": ""
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de credito creada");
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }

        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.anulado,
            "comprobante": this.state.notaDeCredito
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Nota de credito creada");
            this.setState({ notaCreditoDisponible: true });
            this.goToOrdenes();
        }).catch(err => {
            if (this.hasIdEstadoDuplicadoError(err)) {
                this.setState({ notaCreditoDisponible: true });
            }
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    eliminarFactura = () => {
        let data = {
            "idSeller": this.props.orden.seller.codigo,
            "idOrden": this.props.orden.idOrden,
            "idEstado": idEstados.pendiente,
            "comprobante": this.state.factura || ""
        }

        const req = postFacturaOrdenes(data);
        req.then(res => {
            toast.success("Factura eliminada");
            this.goToOrdenes();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        });
    }

    eliminarAnulado = () => {
        if (this.state.facturaCargada && !this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.facturado,
                "comprobante": this.state.factura
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
                this.goToOrdenes();
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }

        if (this.state.facturaCargada && this.state.clickEliminarFactura) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": this.state.notaDeCredito
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }
    }

    estadoPendiente = () => {
        if (this.state.anuladaCargada && this.state.clickEliminarAnulado) {
            let data = {
                "idSeller": this.props.orden.seller.codigo,
                "idOrden": this.props.orden.idOrden,
                "idEstado": idEstados.pendiente,
                "comprobante": ""
            }

            const req = postFacturaOrdenes(data);
            req.then(res => {
                toast.success("Nota de cr�dito eliminada");
                this.goToOrdenes();
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo editarse");
            });
        }
    }

    postArchivo = (e) => {
        e.preventDefault();
        this.estadoPendiente();

        const {
            factura,
            facturaCargada,
            filaAnulado,
            filaFacturado,
            clickEliminarFactura,
            clickEliminarAnulado,
            fechaFacturado
        } = this.state
        const estadoActualId = Number(this.props.orden?.estado?.[0]?.idEstado ?? this.props.orden?.estado?.[0]?.IdEstado);
        const esPendienteActual = estadoActualId === idEstados.pendiente;

        if (facturaCargada && filaAnulado) {
            this.postArchivoNota();
            return;
        }

        if (!filaFacturado && clickEliminarFactura) {
            this.eliminarFactura();
        }

        if (!filaAnulado && clickEliminarAnulado) {
            this.eliminarAnulado();
        }

        if (filaFacturado) {
            if (!factura) {
                toast.warn("El comprobante de factura es requerido");
                return;
            }
            this.postArchivoFactura();
            return;
        }

        if (esPendienteActual && factura) {
            this.postArchivoFactura();
            return;
        }

        if (filaAnulado) {
            if (!factura && fechaFacturado != "") {
                toast.warn("El comprobante de factura es requerido");
                return;
            }
            this.postArchivoNota();
        }
    }

    handleSetIdMotivoAnulacion = (idMotivo) => {
        this.setState({ idMotivoAnulacion: idMotivo });
    };

    goToOrdenes = () => {
        this.props.navigate("/Ordenes");
    }


    render() {
        const { userType, orden } = this.props;
        const isSellerAdminOrIsSeller = userType.isSellerAdmin || userType.isSeller;
        const isSoloLectura = Boolean(userType.isSoloLectura);
        const baseTimelineItems = buildOrderTimeline(orden, null); // estado interno deshabilitado: antes this.state.estadoVentaAprobado
        const existeAnulado = orden?.estado?.some(e => Number(e?.idEstado ?? e?.IdEstado) === 5);
        const anuladaMegatone = orden?.anulacionMegatone?.anulado === true;
        const idEstadoParaSolicitud =
            existeAnulado || anuladaMegatone
                ? idEstados.anulado
                : Number(this.props.orden.estado?.[0]?.idEstado ?? this.props.orden.estado?.[0]?.IdEstado);
        const timelineItems = baseTimelineItems;

        return (
            <div className="tab-pane p-10 active row" name="datos" id="home2" role="tabpanel">

                <div className="col-12">
                    <StatusTimeline
                        title="Estados de la orden"
                        subtitle="Seguimiento visual del circuito de la venta"
                        items={timelineItems}
                    />
                </div>

                <div className="col-12">
                    {(!isSellerAdminOrIsSeller && !isSoloLectura) &&
                        <AnulacionReversion
                            idOrden={this.props.orden.idOrden}
                            idSeller={this.props.idSeller}
                            motivosRechazo={this.props.motivosRevision}
                            goToOrdenes={this.goToOrdenes}
                            orden={this.props.orden}
                            setHabilitarInputs={(value) => this.setState({ habilitarInputs: value })}
                            setHabilitarInputsVte={(value) => this.setState({ habilitarInputsVte: value })}
                            motivoAnulacionSeller={{
                                ...this.props.orden.motivoAnulacion,
                                idMotivo: this.state.idMotivoAnulacion !== "" && this.state.idMotivoAnulacion !== undefined
                                    ? this.state.idMotivoAnulacion
                                    : (this.props.orden.motivoAnulacion?.idMotivo ?? this.props.orden.motivoAnulacion?.id)
                            }}
                            isCategory={userType.isCategory}
                            isAdminMod={userType.isAdminMod}
                            motivosSolicitudAnulacion={this.state.motivosSolicitudAnulacion}
                            idMotivoAnulacion={this.state.idMotivoAnulacion}
                            setIdMotivoAnulacion={this.handleSetIdMotivoAnulacion}
                        />
                    }

                    {isSellerAdminOrIsSeller && !isSoloLectura &&
                        <div className="row p-1 align-content-center">
                            <div className="col-auto">
                                <SolicitudAnulacion
                                    idOrden={this.props.orden.idOrden}
                                    idEstado={idEstadoParaSolicitud}
                                    idSeller={this.props.idSeller}
                                    motivoSolicitudOrden={this.props.orden.motivoAnulacion}
                                    motivosAnulacion={this.state.motivosSolicitudAnulacion}
                                    goToOrdenes={this.goToOrdenes}
                                    idMotivoAnulacion={this.state.idMotivoAnulacion}
                                    setIdMotivoAnulacion={this.handleSetIdMotivoAnulacion}
                                    isSellerAdminOrIsSeller={isSellerAdminOrIsSeller}
                                    orden={this.props.orden}
                                />
                            </div>
                        </div>
                    }
                </div>

                <FormularioDevolucion
                    show={this.state.habilitarInputs}
                    onClose={() => this.setState({ habilitarInputs: false })}
                    montoDevolver={this.state.montoDevolver}
                    cuentaBancaria={this.state.cuentaBancaria}
                    titularCompra={this.state.titularCompra}
                    banco={this.state.banco}
                    cuil={this.state.cuil}
                    numCuenta={this.state.numCuenta}
                    cbu={this.state.cbu}
                    alias={this.state.alias}
                    dni={this.state.dni}
                    numeroComprobante={this.state.numeroComprobante}
                    cupon={this.state.cupon}
                    autorizacion={this.state.autorizacion}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                    onSubmit={this.onSubmit}
                />


                <FormularioDevolucionVte
                    show={this.state.habilitarInputsVte}
                    onClose={() => this.setState({ habilitarInputsVte: false })}
                    cuponVTE={this.state.cuponVTE}
                    autorizacionVTE={this.state.autorizacionVTE}
                    terminal={this.state.terminal}
                    tarjeta={this.state.tarjeta}
                    cuotas={this.state.cuotas}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                    onSubmit={this.onSubmit}
                />
            </div>
        );
    }
}
EstadosOrden.propTypes = {
    navigate: PropTypes.func,
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    orden: PropTypes.shape({
        estado: PropTypes.arrayOf(PropTypes.shape({
            idEstado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            codigo: PropTypes.string,
        }),
        motivoAnulacion: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            detalle: PropTypes.string,
            idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        pago: PropTypes.shape({
            linkFactura: PropTypes.string,
        }),
        anulacionMegatone: PropTypes.shape({
            anulado: PropTypes.bool,
        }),
    }),
    userType: PropTypes.shape({
        isSellerAdmin: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
        isSeller: PropTypes.bool,
        isSoloLectura: PropTypes.bool,
    }),
    motivosRevision: PropTypes.array,
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    userId: state.general.userId,
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    motivosRevision: state.publicaciones.motivosRevision
});

export default connect(mapStateToProps)(EstadosOrdenWrapper);
